export function MadeBy() {
  console.log(`
   ██      ██ ███    ██  ██████  ██       ██████  ███    ██  ██████      ██████  ███    ██ ███████ ██    ██ ███████ 
   ██      ██ ████   ██ ██       ██      ██    ██ ████   ██ ██           ██   ██ ████   ██ ██      ██    ██ ██      
   ██      ██ ██ ██  ██ ██   ███ ██      ██    ██ ██ ██  ██ ██   ███     ██████  ██ ██  ██ █████   ██    ██ ███████ 
   ██      ██ ██  ██ ██ ██    ██ ██      ██    ██ ██  ██ ██ ██    ██     ██      ██  ██ ██ ██      ██    ██      ██ 
   ███████ ██ ██   ████  ██████  ███████  ██████  ██   ████  ██████      ██      ██   ████ ███████  ██████  ███████ 
                                                                                                                    
                                                                                                                    
   `);
}
